module.exports = __webpack_public_path__ + "static/media/firstFrame-lg.ecad721c.webp";